import DestinationFilter from './DestinationFilter'

export default DestinationFilter
